import Cookies from 'js-cookie';

export type Preferences = {
  trackingCookies: boolean;
  recordingCookies: boolean;
};

const nullPreferences: Preferences = {
  trackingCookies: false,
  recordingCookies: false,
};

export default function useCookiePreferences(): Preferences {
  const preferencesJSON = Cookies.get('tcCookieManagement');

  if (!preferencesJSON) return nullPreferences;

  const preferences: Preferences = JSON.parse(preferencesJSON);

  return preferences;
}
